export const MMQuery = `query getMM ($vieweeCompanyId: ID!) {
  companyProfile  (id: $vieweeCompanyId) {
    media {
      url
      mediaType
      created_at
      name
      size
      storageProvider
      username
      password
      tags
    }
    locations {
      name
      id
      products {
        id
        name
      }
    }
  }
}`.replace(/ +(?= )/g, '');

export const editMMMutation = `mutation editCompany($companyId: ID!, $update: CompanyInputType, $companyType: String!) {
  editCompany (companyId: $companyId, update: $update, companyType: $companyType) {
    isMarketingReady
    isLocationMarketingReady
  }
}`.replace(/ +(?= )/g, '');



// WEBPACK FOOTER //
// ./src/app/stores/marketing-materials/marketing-materials-graphql-query.js